// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mx-3";
export var downloadButton = "_mx-4";
export var fileContainer = "_mx-9 _mx-7";
export var fileContainerBase = "_mx-7";
export var fileContainerFixedHeight = "_mx-8 _mx-7";
export var fileInfo = "_mx-5";
export var fileInfoWidthRestricted = "_mx-6";
export var fileType = "_mx-1";
export var fileTypeName = "_mx-2";
export var image = "_mx-0";
export var link = "_mx-b";
export var overflowEllipsis = "_mx-a";